import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCDarklord extends NPC {
    constructor() {
        super(definitions.NPC_ID.DARKLORD);

        this.collisionRadius = 25;
        this.collisionOffsetX = -2;
        this.collisionOffsetY = -34;
        this.interactionRadius = 140;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_the_dark_lord_of_moletown_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 1, new PIXI.Point(-2, -8));
        this.animateIdle(0.4);
    }
}